export function isProjectSchema(data: any): boolean {
  return data && data.componentsTree;
}
